<div [ngClass]="['theme-choice--inner--'+mainStyle.themeName, interlignage, police]">
  <div class="theme-choice--title">
    <div class="theme-choice--title--label" data-cy="panel-title">Choix du thème</div>
    <div class="theme-choice--title--action"><mat-icon (click)="closeDialog()">close</mat-icon></div>
  </div>
  <form [formGroup]="themeChoiceForm">
    <div class="theme-choice--content">
      <div class="theme-choice--content--line">
        <div class="theme-choice--content--line--inner">
          <mat-button-toggle-group  [vertical]="true" formControlName="theme" aria-label="thèmes" (change)="setTheme($event.value)">
            <mat-button-toggle data-cy="theme-choice-theme3-value" [value]="themesNames.theme3">
              {{getThemeName(themesNames.theme3)}}
            </mat-button-toggle>
            <mat-button-toggle data-cy="theme-choice-theme5-value" [value]="themesNames.theme5">{{getThemeName(themesNames.theme5)}}</mat-button-toggle>
            <mat-button-toggle data-cy="theme-choice-theme1-value" [value]="themesNames.theme1">{{getThemeName(themesNames.theme1)}}</mat-button-toggle>
            <mat-button-toggle data-cy="theme-choice-theme2-value" [value]="themesNames.theme2">{{getThemeName(themesNames.theme2)}}</mat-button-toggle>
            <mat-button-toggle data-cy="theme-choice-theme4-value" [value]="themesNames.theme4">{{getThemeName(themesNames.theme4)}}</mat-button-toggle>
          </mat-button-toggle-group>
        </div>
      </div>
    </div>

  </form>
</div>
